import React, { useState } from 'react';
import md5 from 'md5';

import { Avatar, Button, TextField, Typography } from '@riac/design-system';
import { IPostCommentProps } from 'src/components/Comments/PostComment/PostComment.i';

export const PostComment = ({ post, commentId, update, account, handleCancel }: IPostCommentProps) => {
  const [comment, setComment] = useState('');

  const handleText = (e) => {
    setComment(e);
  };

  const handleSubmit = async () => {
    if(comment.length > 0) {
      const req = await fetch(
        '/api/ghost/postBlogComments', {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            postID: post.id,
            replyID: commentId,
            title: post.title,
            comments: comment,
          }),
        });
      const res = await req.json();

      if(res.success) {
        setComment('');
        update();
      }
    }
  };

  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-1'>
        <Typography heading size='sm' weight='bold'>Post a reply</Typography>
        <Typography size='sm'>
          Don't have a profile picture? Sign up at{' '}
          <Button variant='link' className='p-0' to='https://en.gravatar.com/'>https://en.gravatar.com</Button>
          {' '} using your Rock Island Auction account email.
        </Typography>
      </div>
      {account
        && <React.Fragment>
          <div className='flex flex-row gap-2'>
            <Avatar
              src={`https://www.gravatar.com/avatar/${md5(account.Emails[0].Email)}?r=g&d=mp`}
            />
            <div className='flex flex-col'>
              <Typography>Name</Typography>
              <Typography size='sm' weight='bold'>{account.Nickname ? account.Nickname : `${account.FirstName} ${account.LastName}`}</Typography>
            </div>
          </div>
          <TextField
            rows={5}
            multiline
            maxCount={500}
            hasCount
            name="comment"
            maxLength={500}
            value={comment}
            onChange={handleText}
            label='Leave a comment'
          />
          <div className='flex gap-4'>
            <Button onPress={() => handleSubmit()}>Submit Comment</Button>
            {handleCancel
              && <Button variant='secondary' onPress={() => handleCancel()}>Cancel</Button>
            }
          </div>
        </React.Fragment>
      }
    </div>
  );
};
